import { Close, Search } from '@material-ui/icons'
import { TextField } from '@material-ui/core'
import { Colors } from '../../../../../styles'
import {
  Modal,
  ModalTitle,
  TopContent,
  CloseButton,
  ModalHeader,
  ModalContent,
  TotalQuantity,
  WrapperTable,
  NotFoundCell,
  LoadingCell
} from './tally-sheet.styles'
import { Images } from '../../../../../assets'
import { Button, Loading, ModalDel } from '../../../../../components'
import { Table, TableBody } from '@material-ui/core'
import { TableHeaderCustom, TableRowCustom } from './tally-sheet.components'
import useHooks from './tally-sheet.hooks'

const TallySheet = ({ open, handleClose, dataAll }) => {
  const { data, methods } = useHooks({ dataAll })

  const [item] = data.tallySheet

  return (
    <Modal fullWidth open={open} maxWidth='lg'>
      {data.modalDelete.isOpen && (
        <ModalDel
          deleteText='Are you sure you want to delete this Tally Sheet data ?'
          toggleDialog={methods.toggleModalDelete}
          submitDelete={() => methods.onDeleteTallySheet(data.modalDelete.data)}
        />
      )}
      <ModalHeader>
        <ModalTitle>Tally Sheet</ModalTitle>
        <CloseButton onClick={handleClose}>
          <Close htmlColor={Colors.white} />
        </CloseButton>
      </ModalHeader>
      <ModalContent>
        <TopContent>
          <TotalQuantity>
            Total Quantity {item?.calculated_quantity || 0}
          </TotalQuantity>
          <Button
            variant='contained'
            color='blue'
            onClick={methods.handleAddNew}
          >
            <img src={Images.AddIcon} alt='Add Task' />
            &nbsp; Add New
          </Button>
        </TopContent>
        <div>
          <TextField
            fullWidth
            size='small'
            value={data.search}
            variant='outlined'
            placeholder='Search by Material'
            onKeyDown={methods.handleSearchKeyDown}
            onChange={(e) => data.setSearch(e.target.value)}
            InputProps={{
              endAdornment: <Search />
            }}
          />
        </div>
        <WrapperTable>
          <form>
            <Table stickyHeader>
              <TableHeaderCustom />
              <TableBody>
                {data.isFirstLoading ? (
                  <tr>
                    <LoadingCell colSpan={20}>
                      <Loading />
                    </LoadingCell>
                  </tr>
                ) : data.filteredTallySheet.length === 0 ? (
                  <tr>
                    <NotFoundCell colSpan={20}>Data not found</NotFoundCell>
                  </tr>
                ) : (
                  data.filteredTallySheet.map((row, idx) => (
                    <TableRowCustom
                      key={idx}
                      row={row}
                      idx={idx}
                      onBlur={methods.handleUpdate}
                      uomQuantities={data.uomQuantities}
                      materialTypes={data.materialTypes}
                      handleDelete={methods.handleDelete}
                      handleChange={methods.handleChange}
                      handleStart={methods.handleStart}
                      handleStop={methods.handleStop}
                    />
                  ))
                )}
              </TableBody>
            </Table>
          </form>
        </WrapperTable>
      </ModalContent>
    </Modal>
  )
}

export default TallySheet
